module.exports = __webpack_public_path__ + "static/media/mate.e285ff97.png";